import React, { useEffect } from "react";
import { Button } from "reactstrap";

function CatalogSidePanel({
  isOpen,
  onClose,
  title,
  description,
  footer,
  children,
  closeLabel = "Close",
}) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="catalog-side-panel-shell" aria-live="polite">
      <button
        type="button"
        className="catalog-side-panel-backdrop"
        aria-label={closeLabel}
        onClick={onClose}
      />
      <aside
        className="catalog-side-panel"
        role="dialog"
        aria-modal="true"
        aria-label={title || "Side panel"}
      >
        <div className="catalog-side-panel__header">
          <div className="catalog-side-panel__title-wrap">
            <h3 className="catalog-side-panel__title">{title}</h3>
            {description ? (
              <p className="catalog-side-panel__description">{description}</p>
            ) : null}
          </div>
          <Button
            type="button"
            color="link"
            className="catalog-side-panel__close"
            onClick={onClose}
          >
            {closeLabel}
          </Button>
        </div>
        <div className="catalog-side-panel__body catalog-scrollbar-hidden">
          {children}
        </div>
        {footer ? <div className="catalog-side-panel__footer">{footer}</div> : null}
      </aside>
    </div>
  );
}

export default CatalogSidePanel;
